<template>
  <div class="text-center col-lg-1 col-md-2 col-sm-3 col-4">
    <a :class="isActive ? 'bg-gradient-success avatar-xl' : 'avatar-lg'"
      href="javascript:;"
      class="border avatar border-info"
      @mouseover="hover = true"
      @mouseout="hover = false"
    >
      <img :alt="name" class="p-2" :src="image" />
    </a>
    <span :style="{ transform: this.hover & !isActive ? 'translateY(-14px)' : 'translateY(-9px)', transition: '0.35s', marginLeft: isActive ? '63px' :'56px', backgroundColor: isActive ? '#1ae521' :'white' }" 
    style="position: absolute; z-index: 10000; border: 1px solid grey;" :class="isActive ? 'badge-md' : 'badge-sm'" class="badge badge-sm badge-circle text-dark badge-floating"><i :class="isActive ? 'fa fa-check' : null"></i></span>
    <p style="margin-top: 5%;" :class="isActive ? 'text-md' : 'text-sm'" class="mb-0">{{ name }}</p>
  </div>
</template>

<script>
export default {
  name: "StoryAvatar",
  props: {
    image: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    isActive: Boolean
  },
  data() {
    return {
      hover: false
    };
  },
};
</script>
<style scoped>
.avatar:not(.bg-gradient-success):hover{
  transform: translateY(-5px);
}
.avatar-lg, .avatar-xl {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px; /* или любое другое фиксированное значение */
  height: 100px; /* или любое другое фиксированное значение */
  object-fit: cover; /* Это поможет сохранить пропорции изображения */
}

.text-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
